/**
 * Reading JSON the API sent, without trusting its shape: whether a value is a
 * plain object, and a plain object or an empty one to read fields from. The
 * one copy every module imports. Pure.
 */

import type { Json } from '../contracts';

export type JsonObject = { [k: string]: Json };

/** A plain object: not null, not an array. */
export const isObj = (v: unknown): v is JsonObject => typeof v === 'object' && v !== null && !Array.isArray(v);

/** The value as an object to read fields from; `{}` when it is not one. */
export const objectOf = (v: Json | undefined): JsonObject => (isObj(v) ? v : {});
